import type { ReactNode } from 'react'
import { LogoutCornerButton } from '@/components/auth/LogoutCornerButton'

interface Props {
  children: ReactNode
  /**
   * Aperçu en pleine moitié droite (ordinateur) : l'écran se coupe en deux,
   * la question à gauche, le produit à droite du haut en bas.
   */
  panneau?: ReactNode
  /** À droite du logo, dans la barre du haut (ex. l'avancement). */
  entete?: ReactNode
  /** Le panneau contient des commandes (ex. retirer un collègue) : pas masqué aux lecteurs d'écran. */
  panneauInteractif?: boolean
  /**
   * Bouton « Déconnexion » en haut à droite. Retiré de la mise en service
   * après le paiement : le numéro est acheté, on accompagne jusqu'au bout.
   */
  deconnexion?: boolean
}

export function OnboardingNavyShell({ children, panneau, entete, panneauInteractif = false, deconnexion = true }: Props) {
  return (
    <div
      className="relative flex h-dvh w-full flex-col overflow-x-hidden overflow-y-auto"
      style={{ backgroundColor: '#0A192F', fontFamily: 'Inter, sans-serif', color: 'white' }}
    >
      {deconnexion && <LogoutCornerButton variant="dark" />}
      {panneau && (
        <aside
          aria-hidden={panneauInteractif ? undefined : true}
          className="hidden lg:block fixed inset-y-0 right-0 w-1/2 overflow-hidden"
          style={{ backgroundColor: '#0C1D37', borderLeft: '1px solid rgba(255,255,255,0.06)' }}
        >
          {panneau}
        </aside>
      )}
      <div className={`flex flex-col flex-grow ${panneau ? 'lg:w-1/2' : ''}`}>
      <header className="flex items-center justify-between px-6 py-8 md:px-12 lg:px-24">
        <div className="flex items-center gap-2">
          <img
            src="https://sdk.callizy.ca/assets/favicon_callizy.png"
            alt="Callizy"
            className="w-8 h-8 object-contain"
          />
          <span className="text-2xl font-bold tracking-tight">Callizy</span>
        </div>
        {entete}
      </header>

      {children}

      <footer
        className="py-12 text-center text-xs"
        style={{ color: 'rgba(148,163,184,0.3)' }}
      >
        © 2026 Callizy, powered by Workless. Tous droits réservés.
      </footer>
      </div>
    </div>
  )
}
